import { EventEmitter, OnChanges, Output } from "@angular/core";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedger/BcRevenueTransactionsResponseDto";
import { YtdgpRequestDto } from "../../../../core/models/bcLedger/ytdgpRequestDto";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcRevenueTransactionsComponent } from "../bc-revenue-transactions/bc-revenue-transactions.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";

@Component({
  selector: "jni-ytdgp",
  templateUrl: "./ytdgp.component.html",
  styleUrls: ["./ytdgp.component.scss"],
  imports: [BcRevenueTransactionsComponent],
})
export class YTDGPComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  @Input() salesOrderNumberFilter = false;
  ytdgpParams!: YtdgpRequestDto;
  ytdgpList: BcRevenueTransactionsData[] = [];
  TotalBCRevenue!: number;
  TotalBCGP!: number;
  BCAvgMargin!: number;
  TotalBCCommission!: number;
  TotalBCReserve!: number;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _ytdgpService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.ytdgpParams = { ...params } as YtdgpRequestDto;
      this.ytdgpParams.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getYTDGP(this.ytdgpParams);
  }

  getYTDGP(payload: YtdgpRequestDto) {
    this._loaderService.setLoaderState(true);
    this._ytdgpService.ytdgp(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.ytdgpList = res.data.Data ?? [];
          this.TotalBCRevenue = res.data.TotalBCRevenue;
          this.TotalBCGP = res.data.TotalBCGP;
          this.BCAvgMargin = res.data.BCAvgMargin;
          this.TotalBCCommission = res.data.TotalBCCommission;
          this.TotalBCReserve = res.data.TotalBCReserve;
          return;
        }
        this._toastrService.error(res.message ?? "No results found", "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.ytdgpParams = { ...this.bcLedgerStacker };
      this.ytdgpParams.CategoryID = "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
